import React from 'react';
import architectureImg from '../../assets/img/servicetrusted/1.png';

const ServiceTrusted = ({
  title = <><span className="text-primary">Trusted BIM Outsourcing</span> Company for the USA AEC Industry</>,
  paragraphs = [
    "Scan to BIM Services is your trusted BIM outsourcing partner for architects, engineers & contractors in USA. Our professional Building Information Modeling (BIM) services are aimed at improving the design, construction workflow of your projects.",
    "The specialist turns point cloud data, CAD drawings and PDFs into extremely precise BIM models that are filled with information which allow you to remove coordination across teams, reduce expensive rework and support a variety of LOD 100–500 as well as clash detection and create as-built BIM modelling in accordance with U.S. construction regulations.",
    "We save your projects time and money through fast turnaround Revit BIM modeling outsourcing. Get the trust of U.S. clients by collaborating with Scan to BIM Services, who will provide construction-ready, reliable BIM Solutions."
  ],
  buttonText = "Get Your Free BIM Quote Today",
  imgSrc = architectureImg
}) => {
  return (
    <section className="service-trusted-new">
      <div className="trusted-new-container">
        <div className="trusted-new-left">
          <div className="trusted-image-wrapper">
            <img
              src={imgSrc.src || imgSrc}
              alt="US BIM Modeling"
              className="trusted-main-img"
            />
          </div>
        </div>

        <div className="trusted-new-right">
          <h2 className="trusted-new-title">
            {title}
          </h2>

          <div className="trusted-new-content">
            {paragraphs.map((p, index) => (
              <p key={index}>{p}</p>
            ))}
          </div>

          <button className="book-meeting-btn">
            {buttonText}
          </button>
        </div>
      </div>
    </section>
  );
};

export default ServiceTrusted;
